import {
    ACTION_GET_MENU_USER_COMPANY,
    SET_MENU_USER_COMPANY
    
} from "@/shared/components/menu_user_company/store/types/types.js";


import config from "@/shared/components/menu_user_company/config/menu_user_company_api.js";
import PathUri from '@/utils/path_uri';
import axios from '@/plugins/http/axios.js';


const _pathUri = new PathUri(config.port, config.context);

const actions = {
    

    [ACTION_GET_MENU_USER_COMPANY]: async ({ state, commit } ) => {
        return new Promise((resolve, reject) => {
            const menuUserCompany = sessionStorage.getItem("idEmpresa")
           
            try {
                state.loading = true;
    
                axios({
                    method: 'get',
                    url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/empresas/companybyid/${menuUserCompany}`,
                    
                    headers: {
                        'idEmpresa': sessionStorage.getItem("idEmpresa"),
                        'idUsuario': sessionStorage.getItem("idUsuario")
                    }
                })
                .then(resp => {
                                       
                        const products = resp.data.payload                        
                        commit(SET_MENU_USER_COMPANY, products);
                        resolve(resp.data.payload);
                        
                   
                })
                .catch(err => {
                    console.error("Error en la solicitud de empresas:", err);
                    reject(err);
                })
                .finally(() => {
                    state.loading = false;
                });
            } catch (error) {
                console.error("Error en la solicitud de empresas:", error);
                reject(error);
            }
        });
    },

   

};

export default actions;
